import { useState, useEffect } from 'react';
import { useSetHeaderContent } from '../hooks/useAppStore';

export const useMinWidthRequired = (minWidth = 0, shouldPublishHeaderTopic = false) => {
    const [hasMinWidth, setHasMinWidth] = useState(true);

    const updateHeaderContent = useSetHeaderContent();

    useEffect(() => {
        if (!shouldPublishHeaderTopic) return;
        updateHeaderContent("");
    }, [shouldPublishHeaderTopic]);

    useEffect(() => {
        const handleResize = () => {
            if (minWidth === 0) {
                setHasMinWidth(true);
            } else {
                const currentWidth = window.innerWidth;
                setHasMinWidth(currentWidth >= minWidth);
            }
        };

        // Initial check
        handleResize();

        // Add event listener
        window.addEventListener('resize', handleResize);

        // Cleanup event listener
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [minWidth]);

    return hasMinWidth;
};
